export default __webpack_public_path__ + "static/media/profilepic-fallback.7fe14f0a.jpg";